export default __webpack_public_path__ + "static/media/Boguslawa Piela.2e7315ab.webp";